import { TotadminPermission } from 'data/__generated__';

/**
 * Peut-il entrer dans la totadmin ? Un DROIT (`totadmin_access`), jamais un nom de rôle : un groupe composé
 * dans la page « Groupes de permissions » ouvre la porte comme Toteam. Même règle que l'API
 * (`checkAppAccess`), qui calcule `effectivePermissions`.
 */
export const isTotadminUser = ({
    effectivePermissions,
}: {
    effectivePermissions: readonly TotadminPermission[];
}): boolean => effectivePermissions.includes(TotadminPermission.TotadminAccess);
